export default __webpack_public_path__ + "static/media/GoodMannersWithYourFriends_06.dba6c1bb.png";